import { PurchasingAction } from '@daymade/common-lib/dbEnums';
import { ensureSubsetOfKeys } from '@daymade/common-lib/types';
import { z } from 'zod';

import {
  zodSelectOrder,
  zodSelectPaymentRequest,
} from '../generated/zodSchemas.generated';

export const ZPurchasingAction = z.nativeEnum(PurchasingAction);
export const PurchasingActionEnum = PurchasingAction;
export type TPurchasingAction = PurchasingAction;

export const ZOrderSelect = zodSelectOrder
  .pick({
    id: true,
    createdAt: true,
    status: true,
    playerId: true,
    isSubscription: true,
    totalFiatAmount: true,
    tokenAmount: true,
    paymentMethod: true,
    subscriptionId: true,
    utmParams: true,
  })
  .extend(
    ensureSubsetOfKeys(zodSelectOrder.shape, {
      createdAt: z.coerce.date(),
    }),
  );

export const ZPaymentRequestSelect = zodSelectPaymentRequest
  .pick({
    id: true,
    createdAt: true,
    status: true,
    purchasingAction: true,

    totalFiatAmount: true,
    balanceAmount: true,
    giftCardAmount: true,
    promoAmount: true,
    tokenAmount: true,
    discountAmount: true,
    paymentMethodAmount: true,
  })
  .extend(
    ensureSubsetOfKeys(zodSelectPaymentRequest.shape, {
      createdAt: z.coerce.date(),
    }),
  );

export const ZCreateOrderResponse = z.object({
  orderId: z.string(),
  adyenPaymentSession: z
    .object({
      sessionData: z.string(),
      id: z.string(),
      adyenPaymentSessionId: z.string(),
    })
    .optional(),
});
export type TCreateOrderResponse = z.infer<typeof ZCreateOrderResponse>;

export const OrderStatusEnum = ZOrderSelect.shape.status.enum;
